// extracted by mini-css-extract-plugin
export default {"container":"style_container__LRbPd","label":"style_label__ljB76"};